import cart from '@ppcp/cart';
import {isPluginConnected} from '@ppcp/utils';
import {CheckoutGateway} from '../payments/classes';

if (isPluginConnected()) {
    const checkout = new CheckoutGateway(cart, {id: 'ppcp', context: 'checkout'});

    setInterval(() => {
        if (checkout.paypal) {
            checkout.createButton();
        }
    }, 2000);
}